import { createAsyncThunk } from '@reduxjs/toolkit';
import { PulseemResponse } from '../../Models/APIResponse';
import { PulseemReactInstance } from '../../helpers/Api/PulseemReactAPI';

// The logged-in user's own SSO connection (Settings > SSO login).
// WebSiteAPI: Controllers/Settings/MySsoController.cs (api/MySso, api/MySso/Disconnect).
// Connecting itself happens on the web site (/Sso/Connect): the company login proves the identity.

export const getMySso = createAsyncThunk(
    'MySso/Get', async (_, thunkAPI) => {
        try {
            const response = await PulseemReactInstance.get('MySso');
            return response.data as PulseemResponse;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    })

// Once per app start (App.js): does this sub-account use the main account's shared company login? Then the settings
// menu hides "SSO (SAML)" (nothing to set up here). And is there a company login to connect to? Only then "SSO login"
// shows. Stored by commonSlice (this file has only thunks, no state of its own).
export const getSsoMenuInfo = createAsyncThunk(
    'MySso/MenuInfo', async (_, thunkAPI) => {
        try {
            const response = await PulseemReactInstance.get('MySso/MenuInfo');
            return response.data as PulseemResponse;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    })

export const disconnectMySso = createAsyncThunk(
    'MySso/Disconnect', async (_, thunkAPI) => {
        try {
            const response = await PulseemReactInstance.post('MySso/Disconnect');
            return response.data as PulseemResponse;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.message });
        }
    })
